module.exports = __webpack_public_path__ + "static/media/fondo-home-vuelos.424dcffa.jpg";